<template>
  <card-seplag titulo="Data Limite de Solicitacao de Afastamento">
    <div class="p-col-12">
      <div class="p-grid alinhamento">
        <Rotulo nome="Quantidade de dias a mais para aprovação de Ferias:" cols="12 3">
          <InputText type="text" v-model="qdtDiasAmaisValidacao" />
        </Rotulo>
        <div class="p-col-12 p-md-3">
          <Button
            label="Salvar Parâmetro Férias"
            class="p-button-success"
            icon="pi pi-save"
            @click="salvarParametroFerias()"
          />
        </div>
        <hr class="p-col-12" style="margin-bottom: 1rem; margin-top: 1rem" v-if="parametroDiasMinimosAnteLP || parametroIntervaloPedidoLP || parametroAntecedenciaAprovacaoLP"/>
        <Rotulo nome="Dias mínimos de antecedência de solicitação de Licença:" cols="12 3" v-if="parametroDiasMinimosAnteLP">
          <InputText type="text" v-model="parametroDiasMinimosAnteLP.valorParametro" />
        </Rotulo>
        <Rotulo nome="Intervalo de dias entre pedidos do período de Licença:" cols="12 3" v-if="parametroIntervaloPedidoLP">
          <InputText type="text" v-model="parametroIntervaloPedidoLP.valorParametro" />
        </Rotulo>
        <Rotulo nome="Antecedência para aprovação (em Dias) de Licença:" cols="12 3" v-if="parametroAntecedenciaAprovacaoLP">
          <InputText type="text" v-model="parametroAntecedenciaAprovacaoLP.valorParametro" />
        </Rotulo>
        <div class="p-col-12 p-md-3" v-if="parametroDiasMinimosAnteLP || parametroIntervaloPedidoLP || parametroAntecedenciaAprovacaoLP">
          <Button
            label="Salvar Parâmetro Licença"
            class="p-button-success"
            icon="pi pi-save"
            @click="salvarParametroLP()"
          />
        </div>
        <hr class="p-col-12" style="margin-bottom: 1rem; margin-top: 1rem" />
        <Rotulo
          nome="Selecione um Exercicio para data limite de Pedido de Ferias:"
          cols="12 4"
        >
          <Dropdown
            v-model="exercicioSelecionado"
            :options="listaExercicio"
            optionLabel="ano"
            placeholder="Selecione..."
            :filter="true"
            showClear
          />
        </Rotulo>
        <div class="p-col-12 p-md-3">
          <Button
            label="Selecionar"
            class="p-button-info"
            icon="pi pi-check"
            @click="selecionarExercicio()"
          />
        </div>
      </div>
    </div>
    <hr class="p-col-12" />
    <div
      class="p-col-12 p-grid"
      v-if="exibirformulario && exercicioSelecionado"
    >
      <div class="p-col-12 textotitulo">
        <label
          >Datas Cadastradas para o Exercicio
          {{ exercicioSelecionado.ano }}</label
        >
      </div>
      <Rotulo nome="Limite Para Janeiro:" cols="12 2">
        <v-date-picker
          v-model="calendarioDataLimite[0].dataLimite"
          :model-config="datePikerConfig"
          :masks="datePikermasks"
          :first-day-of-week="1"
          is-required
        />
      </Rotulo>
      <Rotulo nome="Limite Para Fevereiro:" cols="12 2">
        <v-date-picker
          v-model="calendarioDataLimite[1].dataLimite"
          :model-config="datePikerConfig"
          :masks="datePikermasks"
          :first-day-of-week="1"
          is-required
        />
      </Rotulo>
      <Rotulo nome="Limite Para Março:" cols="12 2">
        <v-date-picker
          v-model="calendarioDataLimite[2].dataLimite"
          :model-config="datePikerConfig"
          :masks="datePikermasks"
          :first-day-of-week="1"
          is-required
        />
      </Rotulo>
      <Rotulo nome="Limite Para Abril:" cols="12 2">
        <v-date-picker
          v-model="calendarioDataLimite[3].dataLimite"
          :model-config="datePikerConfig"
          :masks="datePikermasks"
          :first-day-of-week="1"
          is-required
        />
      </Rotulo>
      <Rotulo nome="Limite Para Maio:" cols="12 2">
        <v-date-picker
          v-model="calendarioDataLimite[4].dataLimite"
          :model-config="datePikerConfig"
          :masks="datePikermasks"
          :first-day-of-week="1"
          is-required
        />
      </Rotulo>
      <Rotulo nome="Limite Para Junho:" cols="12 2">
        <v-date-picker
          v-model="calendarioDataLimite[5].dataLimite"
          :model-config="datePikerConfig"
          :masks="datePikermasks"
          :first-day-of-week="1"
          is-required
        />
      </Rotulo>
      <Rotulo nome="Limite Para Julho:" cols="12 2">
        <v-date-picker
          v-model="calendarioDataLimite[6].dataLimite"
          :model-config="datePikerConfig"
          :masks="datePikermasks"
          :first-day-of-week="1"
          is-required
        />
      </Rotulo>
      <Rotulo nome="Limite Para Agosto:" cols="12 2">
        <v-date-picker
          v-model="calendarioDataLimite[7].dataLimite"
          :model-config="datePikerConfig"
          :masks="datePikermasks"
          :first-day-of-week="1"
          is-required
        />
      </Rotulo>
      <Rotulo nome="Limite Para Setembro:" cols="12 2">
        <v-date-picker
          v-model="calendarioDataLimite[8].dataLimite"
          :model-config="datePikerConfig"
          :masks="datePikermasks"
          :first-day-of-week="1"
          is-required
        />
      </Rotulo>
      <Rotulo nome="Limite Para Outubro:" cols="12 2">
        <v-date-picker
          v-model="calendarioDataLimite[9].dataLimite"
          :model-config="datePikerConfig"
          :masks="datePikermasks"
          :first-day-of-week="1"
          is-required
        />
      </Rotulo>
      <Rotulo nome="Limite Para Novembro:" cols="12 2">
        <v-date-picker
          v-model="calendarioDataLimite[10].dataLimite"
          :model-config="datePikerConfig"
          :masks="datePikermasks"
          :first-day-of-week="1"
          is-required
        />
      </Rotulo>
      <Rotulo nome="Limite Para Dezembro:" cols="12 2">
        <v-date-picker
          v-model="calendarioDataLimite[11].dataLimite"
          :model-config="datePikerConfig"
          :masks="datePikermasks"
          :first-day-of-week="1"
          is-required
        />
      </Rotulo>
    </div>
    <div
      class="p-col-12 p-md-4"
      v-if="exibirformulario && exercicioSelecionado"
    >
      <Button
        label="Salvar data limite"
        class="p-button-success"
        icon="pi pi-save"
        @click="salvarDatas()"
      />
    </div>
  </card-seplag>
</template>

<script>
import CardSeplag from "@/template/CardSeplag.vue";
import Rotulo from "@/template/RotuloSeplag.vue";
import { baseApiUrl } from "@/config/global";
import moment from "moment";

const getInitiCalendario = () => {
  return [
    {
      dataLimite: null,
      mesReferencia: 1,
      exercicio: null,
    },
    {
      dataLimite: null,
      mesReferencia: 2,
      exercicio: null,
    },
    {
      dataLimite: null,
      mesReferencia: 3,
      exercicio: null,
    },
    {
      dataLimite: null,
      mesReferencia: 4,
      exercicio: null,
    },
    {
      dataLimite: null,
      mesReferencia: 5,
      exercicio: null,
    },
    {
      dataLimite: null,
      mesReferencia: 6,
      exercicio: null,
    },
    {
      dataLimite: null,
      mesReferencia: 7,
      exercicio: null,
    },
    {
      dataLimite: null,
      mesReferencia: 8,
      exercicio: null,
    },
    {
      dataLimite: null,
      mesReferencia: 9,
      exercicio: null,
    },
    {
      dataLimite: null,
      mesReferencia: 10,
      exercicio: null,
    },
    {
      dataLimite: null,
      mesReferencia: 11,
      exercicio: null,
    },
    {
      dataLimite: null,
      mesReferencia: 12,
      exercicio: null,
    },
  ];
};
export default {
  name: "datalimitesocilicitacaoafastamento",
  components: { CardSeplag, Rotulo },
  data: function () {
    return {
      exercicioSelecionado: null,
      listaExercicio: [],
      calendarioDataLimite: getInitiCalendario(),
      exibirformulario: false,
      qdtDiasAmaisValidacao: 0,
      parametroQdtDiasAAmais: null,
      parametroDiasMinimosAnteLP:null,
      parametroIntervaloPedidoLP:null,
      parametroAntecedenciaAprovacaoLP:null,
      datePikerConfig: {
        type: "string",
        mask: "DD/MM/YYYY",
      },
      datePikermasks: {
        input: "DD/MM/YYYY",
      },
      data_inicio: moment().format("DD/MM/YYYY"),
    };
  },
  methods: {
    carregarDados() {
      this.$http.get(`${baseApiUrl}/exercicios/ativos`).then((res) => {
        this.$http
          .post(
            `${baseApiUrl}/parametro/busca`,
            JSON.stringify({
              busca: "QDT_DATA_VALIDACAO",
              idenSistema: process.env.VUE_APP_CODIGO_SISTEMA,
            })
          )
          .then((res2) => {
            this.listaExercicio = res.data;
            if (res2.data.totalElements > 0) {
              this.qdtDiasAmaisValidacao = res2.data.content[0].valorParametro;
              this.parametroQdtDiasAAmais = res2.data.content[0];
            }
          });
        this.$http
          .post(
            `${baseApiUrl}/parametro/busca`,
            JSON.stringify({
              busca: "DIAS_MININO_ANTECEDENCIA_LP",
              idenSistema: process.env.VUE_APP_CODIGO_SISTEMA,
            })
          )
          .then((res3) => {  
            if (res3.data.totalElements > 0) {
              this.parametroDiasMinimosAnteLP =  res3.data.content[0];
            }
          });
        this.$http
          .post(
            `${baseApiUrl}/parametro/busca`,
            JSON.stringify({
              busca: "INTERVALO_DIAS_PEDIDOS_LP",
              idenSistema: process.env.VUE_APP_CODIGO_SISTEMA,
            })
          )
          .then((res4) => {  
            if (res4.data.totalElements > 0) {
              this.parametroIntervaloPedidoLP =  res4.data.content[0];
            }
          });
        this.$http
          .post(
            `${baseApiUrl}/parametro/busca`,
            JSON.stringify({
              busca: "ANTECEDENCIA_APROVACAO_LP",
              idenSistema: process.env.VUE_APP_CODIGO_SISTEMA,
            })
          )
          .then((res5) => {  
            if (res5.data.totalElements > 0) {
              this.parametroAntecedenciaAprovacaoLP =  res5.data.content[0];
            }
          });
      });
    },
    selecionarExercicio() {
      this.exibirformulario = false;
      this.calendarioDataLimite = getInitiCalendario();
      this.$http
        .get(
          `${baseApiUrl}/datalimitesolicitacaoafastamento/${this.exercicioSelecionado.idenExercicio}`
        )
        .then((res) => {
          let datasSalvas = res.data;
          for (let j = 0; j < this.calendarioDataLimite.length; j++) {
            this.calendarioDataLimite[j].exercicio = this.exercicioSelecionado;
          }
          if (datasSalvas.length > 0) {
            for (let i = 0; i < datasSalvas.length; i++) {
              for (let j = 0; j < this.calendarioDataLimite.length; j++) {
                if (
                  this.calendarioDataLimite[j].mesReferencia ==
                  datasSalvas[i].mesReferencia
                ) {
                  this.calendarioDataLimite[j] = datasSalvas[i];
                  break;
                }
              }
            }
          }
          this.exibirformulario = true;
        });
    },
    salvarDatas() {
      this.$http
        .post(
          `${baseApiUrl}/datalimitesolicitacaoafastamento`,
          JSON.stringify(this.calendarioDataLimite)
        )
        .then(() => {
          this.$toast.add({
            severity: "success",
            summary: "Registro Adicionado com Sucesso!",
            life: 3000,
          });
          this.calendarioDataLimite = getInitiCalendario();
          this.selecionarExercicio();
        });
    },
    salvarParametroFerias() {
      this.parametroQdtDiasAAmais.valorParametro = this.qdtDiasAmaisValidacao;
      this.$http
        .put(
          `${baseApiUrl}/parametro/${this.parametroQdtDiasAAmais.idenParametro}`,
          JSON.stringify(this.parametroQdtDiasAAmais)
        )
        .then(() => {
          this.$toast.add({
            severity: "success",
            summary: "Parâmetro Atualizado com Sucesso!",
            life: 3000,
          });
        });
    },
    salvarParametroLP() {
      let atualizado = false;      
      if(this.parametroDiasMinimosAnteLP){
        this.$http
        .put(
          `${baseApiUrl}/parametro/${this.parametroDiasMinimosAnteLP.idenParametro}`,
          JSON.stringify(this.parametroDiasMinimosAnteLP)
        )
        .then(() => {               
          if(!atualizado){
            this.$toast.add({
              severity: "success",
              summary: "Parâmetro Licença Atualizado com Sucesso!",
              life: 3000,
            });
            atualizado = true;
          }  
        });
      }
      if(this.parametroAntecedenciaAprovacaoLP){
        if(this.parametroDiasMinimosAnteLP && this.parametroDiasMinimosAnteLP < this.parametroAntecedenciaAprovacaoLP){          
            this.$toast.add({
              severity:  "error",
              summary: "Parâmetro de Antecedencia Aprovacao de Licença deve ser menor que os dias minimo para solicitação!",
              life: 3000,
            });
            return
        }else{
          this.$http
          .put(
            `${baseApiUrl}/parametro/${this.parametroAntecedenciaAprovacaoLP.idenParametro}`,
            JSON.stringify(this.parametroAntecedenciaAprovacaoLP)
          )
          .then(() => {        
            if(!atualizado){
              this.$toast.add({
                severity: "success",
                summary: "Parâmetro Licença Atualizado com Sucesso!",
                life: 3000,
              });
              atualizado = true;
            }  
          });
        }
      }
      if(this.parametroIntervaloPedidoLP){
        this.$http
        .put(
          `${baseApiUrl}/parametro/${this.parametroIntervaloPedidoLP.idenParametro}`,
          JSON.stringify(this.parametroIntervaloPedidoLP)
        )
        .then(() => {               
          if(!atualizado){
            this.$toast.add({
              severity: "success",
              summary: "Parâmetro Licença Atualizado com Sucesso!",
              life: 3000,
            });
            atualizado = true;
          }  
        });
      }      
    },
  },
  mounted() {
    this.carregarDados();
  },
};
</script>

<style>
.alinhamento {
  align-items: flex-end;
}
.textotitulo {
  display: flex;
  margin: 15px;
  justify-content: center;
  font-size: 17px;
  font-weight: 600;
  color: rgb(110, 106, 106);
}
hr {
  border: 1px solid #d5d5d5;
  padding: 0px !important;
}
</style>